import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import BotaoVoltar from "../../components/BotaoVoltar";
import api from "../../services/api";

export default function BuscarGrupoPublico() {
    const [grupos, setGrupos] = useState([]);
    const [busca, setBusca] = useState("");
    const [loading, setLoading] = useState(true);
    const [erro, setErro] = useState("");

    const navigate = useNavigate();

    // ---------------------------------------------
    // Carrega os 10 grupos públicos mais recentes
    // ---------------------------------------------
    const loadIniciais = async () => {
        try {
            const r = await api.get("/grupos/publicos/buscar/");
            setGrupos(r.data);
        } catch (e) {
            console.error("Erro ao carregar grupos públicos:", e);
            setErro("Não foi possível carregar os grupos.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadIniciais();
    }, []);

    // ---------------------------------------------
    // Busca por nome
    // ---------------------------------------------
    const buscar = async () => {
        if (!busca.trim()) {
            loadIniciais();
            return;
        }

        setLoading(true);
        setErro("");

        try {
            const r = await api.get(`/grupos/publicos/buscar/?q=${busca}`);
            setGrupos(r.data);
        } catch (e) {
            console.error(e);
            setErro("Erro ao buscar grupos.");
        } finally {
            setLoading(false);
        }
    };

    // ---------------------------------------------
    // Entrar em grupo público
    // ---------------------------------------------
    const participar = async (grupoId) => {
        try {
            await api.post(`/grupos/${grupoId}/entrar/`);
            navigate(`/grupos/${grupoId}`);
        } catch (e) {
            console.error(e);
            alert("Erro ao entrar no grupo público.");
        }
    };

    // ---------------------------------------------
    // Render
    // ---------------------------------------------
    return (
        <>
            <Navbar />

            <div className="container mt-4">
                
                {/* Cabeçalho */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="fw-bold mb-0">Buscar grupos públicos</h2>

                    <BotaoVoltar to="/grupos" />
                </div>

                <div className="card shadow-sm p-4">

                    {/* Campo de busca */}
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Buscar grupo pelo nome"
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                        />

                        <button
                            className="btn btn-primary"
                            onClick={buscar}
                            disabled={loading}
                        >
                            {loading ? "Buscando..." : "Buscar"}
                        </button>
                    </div>

                    {erro && <div className="alert alert-danger">{erro}</div>}

                    {loading ? (
                        <p>Carregando grupos...</p>
                    ) : grupos.length === 0 ? (
                        <div className="alert alert-info">Nenhum grupo público encontrado.</div>
                    ) : (
                        <ul className="list-group">
                            {grupos.map((g) => (
                                <li
                                    key={g.id}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                    <div className="d-flex align-items-center">
                                        <img
                                            src={g.imagem_capa || "/grupo-default.png"}
                                            width={45}
                                            height={45}
                                            className="rounded-circle me-3"
                                            style={{ objectFit: "cover" }}
                                            alt={g.nome}
                                        />

                                        <div>
                                            <div className="fw-bold">{g.nome}</div>
                                            <small className="text-muted">
                                                {g.membros_ativos} membros
                                            </small>
                                        </div>
                                    </div>

                                    <button
                                        className="btn btn-success btn-sm"
                                        onClick={() => participar(g.id)}
                                    >
                                        Participar
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}

                </div>
            </div>
        </>
    );
}
